<script lang="ts" >
import Component from 'vue-class-component'
import AdminList from '@/components/admin/AdminList.vue'
import { AloDbUmbType } from '@/models/alodb/AloDbUmbType'

@Component({
  name: 'AdminUmbTypeList'
})

export default class AdminUmbTypeList extends AdminList<AloDbUmbType> {  
 
  get itemTypeName() {
    return "UmbType"
  }

}
</script>